import { Loading, Message, MessageBox } from 'element-ui'
import _ from 'lodash'

const computeRate = function (rate) {
  if (rate >= 0) {
    let result = ('' + _.round(rate * 100, 2)).substr(0, 4)
    if (result === '100') {
      return result
    } else if (result.indexOf('.') === -1) {
      result += '.0'
    }
    return result
  } else {
    let result = ('' + _.round(rate * 100, 2)).substr(0, 5)
    if (result.indexOf('.') === -1) {
      result += '.0'
    }
    return result
  }
}
/* 把对象的值里的数组转换成逗号分割的字符串 */
const formatArrayToString = function (data) {
  return _.mapValues(data, function (o) {
    if (_.isArray(o)) {
      return _.join(o, ',')
    } else {
      return o
    }
  })
}

/* 把对象的值里的逗号分割的字符串转换成数组 */
const formatStringToArray = function (data) {
  return _.mapValues(data, function (o) {
    if (!o) {
      return o
    } else if (_.isString(o)) {
      return o.split(',')
    } else {
      return o
    }
  })
}

const exportFile = async ({ method, url, data }) => {
  let loadingInstance = Loading.service()
  try {
    let response = await window.instance({
      method,
      responseType: 'blob',
      url,
      data
    })

    // console.log('response', response)
    let fileName = response.headers['content-disposition'].split("''")[1]
    if (!fileName) {
      fileName = response.headers['content-disposition'].split('=')[1]
    }
    fileName = decodeURI(fileName)

    let isZip = fileName.endsWith(".zip")

    let res = response.data
    const blob = new Blob([res], { type: isZip? 'application/zip':'application/vnd.ms-excel' })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = fileName
    a.click()
    URL.revokeObjectURL(a.href)
    a.remove()
    return { data: response, fileName }
  } catch (e) {
    Message.error({
      message: '系统异常'
    })
  } finally {
    loadingInstance.close()
  }
}

/* 提交数据的时候,对多语言字段进行转换
* data是需要被转换的数据对象
* keys是数组,是需要被转换的key,在key的后面去掉'Multi'
* */
const transformMulti = function (data, keys) {
  const submitData = _.cloneDeep(data)
  _.each(keys, (key) => {
    if (_.has(submitData, key)) {
      const pureKey = key.replace('Multi', '')
      submitData[pureKey] = submitData[key]['zh_CN']
    }
  })
  return submitData
}

/* 获取当前的月份 */
const getCurrentMonth = function (data, keys) {
  let date = new Date()
  let curYear = date.getFullYear()
  let m = date.getMonth() + 1
  let curMonth = m < 10 ? '0' + m : m
  let d = date.getDate()
  let curDay = d < 10 ? ('0' + d) : d
  let startDate = `${curYear}-${curMonth}-01`
  let endDate = `${curYear}-${curMonth}-${curDay}`
  return {
    dateType: 'month',
    startTime: startDate,
    endTime: endDate
  }
}

/**
 * 操作二次确认
 * @param description {String} 提示内容
 * @returns 
 */
const secondConfirm = async function (description){
  return await MessageBox.confirm(description, '提示', {
    confirmButtonText: '确认',
    cancleButtonText: '取消',
    type: 'warning'
  }).then(()=>true).catch(()=>{
    Message.info("操作取消！")
    return false
  });
}

export default {
  formatArrayToString,
  formatStringToArray,
  computeRate,
  exportFile,
  transformMulti,
  getCurrentMonth,
  secondConfirm
}



// WEBPACK FOOTER //
// ./src/openSurvey/utils/tools.js